class Members {

    
    /**
     * Returns an Array with all users
     * @return array[]
    **/
    static getMembersList = async() =>{

        let fetchRequest = await fetch("https://dashboard.realsexdoll.info/php/users/users.php");
        const result = await fetchRequest.json();
        return result;

    }
    /**
     * Returns an Array ready to make a
     * Select list
     */
    static getMembersSelectList = async() =>{

        let fetchRequest = await fetch("https://dashboard.realsexdoll.info/php/users/users.php");
        const result = await fetchRequest.json();

        let ArrayList = [];

        for(let member of result){
            ArrayList.push({value: member.username, label: member.username})
        }
        return ArrayList;

    }


}
  
export default Members;